// extracted by mini-css-extract-plugin
module.exports = {"Title":"+2thXbt2ja+KWQ6l4nmsQg=="};